import { useMutation, useQuery } from "@tanstack/react-query";

import { CompanyLinkData } from "../../../pages/CompanyResources/schema";

import {
	addEditCompanyLink,
	deleteCompanyLink,
	getCompanyLinks,
	incrementCompanyLinkScore,
} from "../../services/defs/company-links";

export const useCompanyLinks = () => {
	return useQuery<CompanyLinkData>({
		queryKey: ["company-links"],
		queryFn: () => getCompanyLinks(),
		retry: 1,
	});
};

export const useDeleteCompanyLink = () => {
	return useMutation({ mutationFn: deleteCompanyLink });
};

export const useAddEditCompanyLink = () => {
	return useMutation({ mutationFn: addEditCompanyLink });
};

export const useIncrementCompanyLinkScore = () => {
	return useMutation({ mutationFn: incrementCompanyLinkScore });
};
